import React, { useState, useReducer, useEffect } from "react";

import {
    Box,
    Divider,
    Grid,
    Typography,
    Button,
    IconButton,
    styled,
    Card,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
    Badge,
    Tooltip
} from '@mui/material';

import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { useSystemUtils } from "../../../hooks/useSystemUtils";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useDocuments, documentTypes, targetTypes as targetDocumentTypes } from "../../../hooks/api/useDocuments";
import { useLocations, locationTypes, targetTypes } from "../../../hooks/api/useLocations";
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useAppContextFeatures } from "../../../context/AppContext";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";

import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from "../../common/CommonBreadcumbs";
import CommonRestricted from "../../common/CommonRestricted";

import { CommonIcons, icons } from "../../common/CommonIcons";

import {
    documentTypes as validationDocumentTypes,
    targetTypes as validationTargetTypes,
    actionTypes as validationActionTypes
} from "../../../hooks/api/useDocumentValidation";

import VerifyTransferInSaved from "../../@documentValidation/verifyTransferIn/VerifyTransferInSaved";
import VerifyTransferInNew from "../../@documentValidation/verifyTransferIn/VerifyTransferInNew";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3)
}));

const StyledLabel = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem',
    fontWeight: 800
}))

const StyledContent = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem'
}))

const StyledContent2 = styled(Typography)(({ theme }) => ({
    fontSize: '0.8rem',
    mt: 2
}))

const StyledDivider = styled(Divider)(({ theme }) => ({
    mt: 1,
    mb: 0,
    borderStyle: 'dashed'
}))

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: -3,
        top: 13,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));

export default function VerifyTransferInTransferReturn({
    routeType
}) {

    const { id } = useParams();
    const [searchParams, setSearchParams] = useSearchParams()

    const { setSystemLoading, openCustomDrawer, closeCustomDrawer } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)

    const { get: getDocument } = useDocuments({
        documentType: documentTypes.transferReturn,
        targetType: targetDocumentTypes.transferReturn
    });
    const { list: getLocationRacks } = useLocations({ locationType: locationTypes.rack, targetType: targetTypes.rack });
    const { formatCurrencyDisplay } = useSystemUtils();

    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.transferReturn.id)

    const navigate = useNavigate();

    const [data, setData] = useState()
    const [rackData, setRackData] = useState()

    const fetchData = async () => {

        setSystemLoading(true);

        try {

            let response = await getDocument({ id });

            // console.log('response?.data?.items', response?.data)
            setData(response?.data)

            const locationId = response?.data?.document?.to_location_id;

            const props = {
                limit: 10000,
                skip: 0,
                sortInfo: {
                    id: "rack_name",
                    dir: -1
                }
            }

            props.parentId = locationId
            props.locationType = locationTypes.rack;

            const { data } = await getLocationRacks(props)
            // console.log('warehouseRacks', warehouseRacks, params)

            // for(let i = 0; i < data.racks.length; i+=1){
            data.racks.map(item => {

                let b = item?.slots;

                let newSlots = [];

                if (b) {

                    Object.keys(b).map((item2, index2) => {
                        // console.log('value', item2)
                        newSlots.push({
                            id: item2,
                            name: b[item2]
                        })
                        return false;
                    })
                }

                item._slots = newSlots;

                return false;
            })

            // console.log(data.racks)

            setRackData(data.racks)

        } catch (error) {

            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

    }

    useEffect(() => {

        fetchData();

    }, [])

    // const handleChangeTab = (event, newValue) => {
    //     console.log('value', newValue, event)
    //     setTabValue(newValue);
    // };

    const RenderDrawerSaved = ({ row, handleOnSuccess }) => {

        let enableEdit = true

        // check permission
        if (isPermissionAllow({ functionType: functionTypes.verifyTransferInUndo.id }) === false)
            enableEdit = false

        return (
              <>
                  {
                      VerifyTransferInSaved({
                          row,
                          enableEdit,
                          documentType: validationDocumentTypes.transferReturn,
                          targetType: validationTargetTypes.transferReturn,
                          actionType: validationActionTypes.verifyTransferIn.transferReturn,
                          // handleOnSuccess
                      })
                  }
              </>
        )
    }

    const RenderDrawerNew = ({ row, rackData, handleOnSuccess }) => {
        return (
              <>
                  {
                      VerifyTransferInNew({
                          row,
                          rackData,
                          documentType: validationDocumentTypes.transferReturn,
                          targetType: validationTargetTypes.transferReturn,
                          actionType: validationActionTypes.verifyTransferIn.transferReturn,
                          handleOnSuccess
                      })
                  }
              </>
        )
    }

    const openSaved = ({ row, rackData }) => {
        openCustomDrawer({
            show: true,
            anchor: "right",
            title: `Saved Validation`,
            PaperProps: {
                sx: { width: 5 / 6 }
            },
            handleOnClose: () => { fetchData() },
            ComponentActions:
                  <>
                      <Button
                            variant="contained"
                            // color={"primary"}
                            size="small"
                            onClick={() => openNew({ row, rackData })}
                      >
                          New Validation
                      </Button>
                  </>,
            ComponentBody:
                  <>
                      <RenderDrawerSaved
                            row={row}
                            handleOnSuccess={() => {
                                closeCustomDrawer();
                                fetchData()
                            }}
                      />
                  </>
        })
    }

    const openNew = ({ row, rackData }) => {

        openCustomDrawer({
            show: true,
            anchor: "right",
            title: `Add New Validation`,
            PaperProps: {
                sx: { width: 2 / 3 }
            },
            handleOnClose: () => { fetchData() },
            ComponentActions:
                  <Button
                        variant="contained"
                        // color={"primary"}
                        size="small"
                        onClick={() => openSaved({ row, rackData })}
                  >
                      View Saved Validation
                  </Button>,
            ComponentBody:
                  <RenderDrawerNew
                        row={row}
                        rackData={rackData}
                        handleOnSuccess={() => {
                            closeCustomDrawer();
                            fetchData()
                        }}
                  />
        })

    }

    const RenderButtonLogs = ({ row }) => {

        // check permission
        if (isPermissionAllow({ functionType: functionTypes.verifyTransferInLogs.id }) === false) return <></>

        return (
              <Tooltip title={`${row?.verify_in_uids ? row.verify_in_uids.length: "0"} Validation Saved`}>
                  <IconButton
                        size="small"
                        color={"primary"}
                        onClick={() => {

                            openSaved({ row, rackData })
                        }}
                  >

                      <StyledBadge
                            badgeContent={
                                row?.verify_in_uids ? row.verify_in_uids.length: "0"
                            }
                            color="secondary"
                      >
                          <CommonIcons name={icons.history}/>
                      </StyledBadge>
                  </IconButton>
              </Tooltip>
        )
    }

    const RenderButtonNew = ({ row }) => {

        // check permission
        if (isPermissionAllow({ functionType: functionTypes.verifyTransferInNew.id }) === false) return <></>

        return (
              <Tooltip title={`New Validation`}>
                  <IconButton
                        size="small"
                        color={"primary"}
                        onClick={() => {
                            openNew({ row, rackData })
                        }}
                  >
                      <CommonIcons name={icons.add}/>
                  </IconButton>
              </Tooltip>
        )
    }

    const RenderTableRow = ({ row, rackData, viewOnly }) => {
        return (
              <>
                  <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                      <TableCell>{(row.index + 1)}</TableCell>
                      <TableCell component="th" scope="row">
                          {row.item_name}
                      </TableCell>
                      {/* <TableCell>{row.description}</TableCell> */}
                      <TableCell>{row.code}</TableCell>
                      <TableCell align="right">
                          {parseFloat(row.verify_in_qty)} / {parseFloat(row.qty)} {row.uom_name}
                      </TableCell>
                      {/* <TableCell align="right">A101, A201</TableCell> */}
                      <TableCell align="right">

                          {
                              parseFloat(row.unverify_in_qty) > 0 ?
                                    (
                                          <Chip
                                                icon={
                                                    <CommonIcons name={icons.warning} sx={{ ml: 1 }}/>
                                                }
                                                label={
                                                    `Required ${parseFloat(row.unverify_in_qty)}`
                                                }
                                                color='warning'
                                                variant="contained"
                                                // sx={{
                                                //     width: '100%'
                                                // }}
                                                // size="small"
                                          />
                                    )
                                    :
                                    (
                                          <Chip
                                                icon={
                                                    <CommonIcons name={icons.tick} sx={{ ml: 1 }}/>
                                                }
                                                label={`Completed`}
                                                color='primary'
                                                variant="contained"
                                                // sx={{
                                                //     width: '100%'
                                                // }}
                                                // size="small"
                                          />
                                    )
                          }

                      </TableCell>
                      <TableCell align="right">
                          <RenderButtonLogs
                                row={row}
                          />
                          <RenderButtonNew
                                row={row}
                          />
                      </TableCell>
                  </TableRow>
                  {/* <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                        {
                            RenderCollapse()
                        }
                    </TableCell>
                </TableRow> */}
              </>
        )
    }

    const RenderTable = () => {

        if (!data) return <></>

        return (
              <TableContainer
                    // component={Paper}
                    sx={{
                        // minHeight: 400,
                        // maxHeight: 400
                    }}
              >
                  <Table
                        size="small"
                        stickyHeader
                  >
                      <TableHead>
                          <TableRow>
                              <TableCell>#</TableCell>
                              <TableCell>Name</TableCell>
                              <TableCell>Code</TableCell>
                              <TableCell align="right">Qty</TableCell>
                              <TableCell align="right">Balance</TableCell>
                              <TableCell align="right"><></>
                              </TableCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                          {
                              data?.items.map((row, index) => (
                                    <RenderTableRow
                                          key={index}
                                          row={{ ...row, index }}
                                          rackData={rackData}
                                    />
                              ))
                          }

                      </TableBody>
                  </Table>
              </TableContainer>
        )
    }

    const RenderFormProfile = () => {

        const {
            document
        } = data

        return (
              <StyledCard>
                  <Grid container spacing={0.5}>
                      <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                          <CommonSectionHeader
                                title={`Profiles`}
                                subTitle={`Related profiles attached to document`}
                          />

                      </Grid>

                      <Grid item xs={12}>
                          <StyledDivider/>
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                          <Grid container spacing={0.5}>

                              <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                  <StyledLabel>From Location</StyledLabel>
                              </Grid>

                              <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                  <StyledContent>
                                      {document?.location_name}
                                  </StyledContent>
                                  <StyledContent2>
                                      {document?.state_name}
                                  </StyledContent2>
                              </Grid>


                              <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                  <StyledLabel>Location To</StyledLabel>
                              </Grid>

                              <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                  <StyledContent>
                                      {document?.to_location_name}
                                  </StyledContent>
                                  <StyledContent2>
                                      {document?.to_location_address_1} {document?.to_location_address_2}
                                      {document?.to_postcode}, {document?.to_area} {document?.to_country}
                                  </StyledContent2>
                              </Grid>

                          </Grid>
                      </Grid>

                  </Grid>
              </StyledCard>
        )
    }

    const RenderFormDocument = () => {
        return (
              <StyledCard>
                  <Grid container spacing={0.5}>
                      <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                          <CommonSectionHeader
                                title={`Document`}
                                subTitle={`Basic information about the document`}
                          />

                      </Grid>
                      <Grid item xs={12}>
                          <StyledDivider/>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                          <Grid container spacing={0.5}>

                              <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                  <StyledLabel>Document No.</StyledLabel>
                              </Grid>
                              <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                  <StyledContent>
                                      {data?.document.doc_number}
                                  </StyledContent>
                              </Grid>

                              <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                  <StyledLabel>Document Date</StyledLabel>
                              </Grid>
                              <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                  <StyledContent>
                                      {data?.document.doc_date}
                                  </StyledContent>
                              </Grid>

                              <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                  <StyledLabel>
                                      Remark
                                  </StyledLabel>
                              </Grid>
                              <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                  <StyledContent>
                                      {data?.document.doc_remark}
                                  </StyledContent>
                              </Grid>

                          </Grid>
                      </Grid>
                  </Grid>
              </StyledCard>
        )
    }

    const RenderForm = () => {

        if (!data) return <></>

        return (
              <>
                  <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} md={7} textAlign={"left"}>
                          {
                              RenderFormDocument()
                          }
                      </Grid>
                      <Grid item xs={12} sm={12} md={5} textAlign={"left"}>
                          {
                              RenderFormProfile()
                          }
                      </Grid>
                  </Grid>

                  <Box
                        sx={{
                            textAlign: 'left',
                            mt: 3,
                            pl: 0.5,
                        }}
                  >
                      <CommonSectionHeader
                            title={`Items`}
                            subTitle={`Detail information about the items involved`}
                      />
                  </Box>

                  <StyledCard
                        sx={{
                            mt: 1.5,
                            p: 0
                        }}
                  >
                      <Grid container rowSpacing={0}>

                          <RenderTable/>

                      </Grid>
                  </StyledCard>
                  <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                      <Grid item md={12} textAlign={"center"}>
                          <Button
                                type="button"
                                // fullWidth
                                variant="contained"
                                sx={{
                                    mt: 3,
                                    mb: 2
                                }}
                                // loading={isLoading}
                                onClick={() => navigate(-1)}
                          >
                              Back
                          </Button>
                      </Grid>
                  </Grid>
              </>
        )
    }

    return (
          <Box>
              {
                  getHtmlHead({ routeType, title: headTitles.verifyInTransferReturn })
              }

              <CommonBreadcumbs
                    routeType={routeType}
                    pageTitle={`Verify Transfer In ${data?.document.doc_number}`}
                    breadcrumbs={[
                        {
                            displayText: "Transfer Returns",
                            props: {
                                href: getRoute("documents/transferReturns")
                            }
                        },
                        {
                            displayText: `#${data?.document.doc_number}`,
                            props: {
                                color: 'secondary.main',
                            }
                        },
                    ]}
              />

              {
                  isPermissionAllow({ functionType: functionTypes.pageVerifyTransferIn.id }) ?
                        RenderForm()
                        :
                        <CommonRestricted/>
              }

          </Box>
    )
}